export enum EPeriodOptions {
  today = 'today',
  yesterday = 'yesterday',
  past7days = 'past7days',
  priorWeek = 'priorWeek',
  past30days = 'past30days',
  monthToDate = 'monthToDate',
  priorMonth = 'priorMonth',
  quarterToDate = 'quarterToDate',
  priorQuarter = 'priorQuarter',
  yearToDate = 'yearToDate',
  priorYear = 'priorYear',
  custom = 'custom',
}

export interface IDateRange<T extends string | Date = Date> {
  startDate: T; // eg '01/01/2022' or an instance of Date
  endDate: T; // eg '01/01/2022' or an instance of Date
}

export interface IPeriod {
  name: EPeriodOptions;
  displayName: string;
  customDateRange?: IDateRange<string> | IDateRange<Date>;
}

export interface IMonthVsMonth {
  firstMonth: string | null; // eg 'January-2022'
  secondMonth: string | null; // eg 'January-2022'
}
